<template>
  <section v-loading="loading" class="pos-r">
    <div class="back">
      <div class="back__arrow" @click="$emit('back')" />
      <div class="back__title">Заявка на погрузку</div>
    </div>
    <div class="wrapper mod-start">
      <div class="choice">
        <div class="choice__title">Запись на погрузку</div>
      </div>

      <bid-mobile :bid="bid" :day="day" :freight="freights[bid.freight_id]" />

      <el-row v-if="requiredDocuments.length" class="bidDocuments">
        <div class="bidDocuments__title">
          До записи на погрузку удостоверьтесь, что в наличии есть или точно
          будут следующие документы:
        </div>

        <el-checkbox-group
          v-model="documentsChecklist"
          class="bidDocuments__checkboxes"
        >
          <el-checkbox
            v-for="item in requiredDocuments"
            :key="item.id"
            :label="item.id"
            class="bidDocuments__checkboxes-item"
          >
            {{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-row>
      <div class="buttons">
        <div
          :class="['button primary', { disabled: !isConfirmEnable }]"
          @click="handleAddAuto"
        >
          Добавить авто и водителя
        </div>
      </div>
    </div>
    <driver-add-mobile
      :added="added"
      :visible="addAuto"
      :day="day"
      :info-source="infoSource"
      :bid="bid"
      :freight="freights[bid.freight_id]"
      @changed="updated"
      @close-truck="addAuto = false"
    />
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import BidMobile from '../BidMobile/index'
import DriverAddMobile from './components/DriverAddMobile'

const Documents = RepositoryFactory.get('organizations')

export default {
  name: 'LoadDayMobile',
  components: {
    DriverAddMobile,
    BidMobile,
  },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    day: {
      type: Object,
      default: () => {},
    },
    freights: {
      type: Object,
      default: () => {},
    },
    infoSource: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      addAuto: false,
      editAuto: false,
      response: {},
      requiredDocuments: [],
      documentsChecklist: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters({ responses: 'loadDay/getResponses' }),
    added() {
      const obj = { autos: [], drivers: [] }

      for (let k in this.responses) {
        if (!Object.prototype.hasOwnProperty.call(this.responses, k)) {
          continue
        }
        const { automobile_id, driver_id } = this.responses[k]

        obj.autos.push(automobile_id)
        obj.drivers.push(driver_id)
      }

      return obj
    },
    isConfirmEnable() {
      return (
        this.requiredDocuments.length === this.documentsChecklist.length ||
        !this.requiredDocuments.length
      )
    },
  },
  async mounted() {
    this.getResponses()

    this.loading = true
    const { data } = await Documents.getBidRequiredDocuments(
      this.bid.org_client_id,
    )

    this.requiredDocuments = data
    this.loading = false
  },
  methods: {
    ...mapActions({
      fetchResponsesInDay: 'loadDay/fetchResponsesInDay',
      fetchHomeBid: 'bids/fetchHomeBid',
    }),
    handleAddAuto() {
      if (this.isConfirmEnable) {
        this.addAuto = true
      }
    },
    updated(flag = 1) {
      this.addAuto = false

      if (flag) {
        this.getResponses()
        this.fetchHomeBid({
          bid_id: this.bid.id,
          user_type: this.userInfo.user_type,
        })
      }
      this.$emit('response-complete')
    },
    getResponses() {
      if (this.day.id) {
        this.fetchResponsesInDay({
          load_day_id: this.day.id,
          'per-page': 200,
          with_stats: 0,
        })
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.pos-r
  position: relative
::v-deep .v-modal
  background: rgb(43, 43, 43)
.fixed-button
  position: fixed;
  bottom: 7rem
  left: 0
  right: 0
  padding: 1.6rem 0.8rem
  background: #FFFFFF
  box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)
  z-index: 50

.bidDocuments
  margin: 40px 20px 30px
  &__title
    font-size: 1.4rem
  &__checkboxes
    gap: 2rem
    &-item ::v-deep .el-checkbox__label
      font-size: 1.2rem
</style>
